// C:\xampp\htdocs\sait\client\src\App.js

import React, {useContext, useEffect, useLayoutEffect, useRef, useState} from 'react';
import {BrowserRouter} from "react-router-dom";
import AppRouter from "./AppRouter";
import NavBar from "./components/layout/header/NavBar/NavBar";
import Navigation from "./components/layout/header/Navigation/Navigation";
import {observer} from "mobx-react-lite";
import {Context} from "./index";
import {check} from "./http/userApi";
import Loading from "./components/commons/Loading/Loading";
import {
    fetchArea,
    fetchBedroom,
    fetchBuilding,
    fetchFloor,
    fetchHeating,
    fetchParking,
    fetchRepair,
    fetchRoom
} from "./http/paramsApi";
import MobileBottomNav from "./components/layout/MobileBottomNav/MobileBottomNav/MobileBottomNav";

import './styles/base/global.css'

import CookieConsentBanner from "./components/layout/CookieConsentBanner/CookieConsentBanner"; // 👈 добавим баннер

import {YMInitializer} from "react-yandex-metrika";

const App = observer(() => {
    const {user, add, helper} = useContext(Context)
    const [isLoading, setIsLoading] = useState(true)

    const navBarRef = useRef(null);
    const navigationRef = useRef(null);

    const [cookiesAccepted, setCookiesAccepted] = useState(false);

    // Функция проверки и обновления статуса пользователя
    const initializeUser = async () => {
        try {
            const userData = await check(); // check обновляет access token
            if (userData) {
                user.setIsAuth(true);
                user.setUserData(userData);
            } else {
                user.setIsAuth(false);
                localStorage.removeItem('token'); // удаляем access token
                document.cookie = 'refreshToken=; Max-Age=0; path=/'; // удаляем refresh token
            }
        } catch (e) {
            user.setIsAuth(false);
            localStorage.removeItem('token'); // удаляем access token
            document.cookie = 'refreshToken=; Max-Age=0; path=/'; // удаляем refresh token
        }
    };

    // Объединяем всю логику инициализации в одном useEffect
    useEffect(() => {
        const initializeApp = async () => {
            try {
                // 2. Загружаем фильтры
                const [
                    bedrooms, buildings, floors, rooms,
                    heatings, repairs, parkings, areas
                ] = await Promise.all([
                    fetchBedroom(), fetchBuilding(), fetchFloor(), fetchRoom(),
                    fetchHeating(), fetchRepair(), fetchParking(), fetchArea()
                ]);

                add.setBedrooms(bedrooms);
                add.setBuildings(buildings);
                add.setFloors(floors);
                add.setRooms(rooms);
                add.setHeatings(heatings);
                add.setRepairs(repairs);
                add.setParkings(parkings);
                add.setAreas(areas);

                await initializeUser();
            } catch (error) {
                console.error("Ошибка инициализации приложения:", error);
            } finally {
                user.setIsLoaded(true);
                setIsLoading(false);
            }
        };

        initializeApp();
    }, []);

    // Проверка токена при возвращении на вкладку
    useEffect(() => {
        const handleVisibilityChange = async () => {
            if (document.visibilityState === 'visible') {
                await initializeUser();
            }
        };

        document.addEventListener('visibilitychange', handleVisibilityChange);
        return () => {
            document.removeEventListener('visibilitychange', handleVisibilityChange);
        };
    }, []);

    useLayoutEffect(() => {
        if (!isLoading && navBarRef.current && navigationRef.current) {
            helper.setNavBarHeight(navBarRef.current.offsetHeight);
            helper.setNavigationHeight(navigationRef.current.offsetHeight);
        }
    }, [helper, isLoading, navBarRef, navigationRef]);

    // Общее условие для отображения Loading
    if (isLoading) {
        return (
            <Loading/>
        );
    }

    return (
        <BrowserRouter>
            {cookiesAccepted && (
                <YMInitializer accounts={[99134839]} options={{webvisor: true}} />
            )}
            <NavBar ref={navBarRef} />
            <Navigation ref={navigationRef} />
            <AppRouter/>
            <MobileBottomNav/>

            <CookieConsentBanner onAccept={() => setCookiesAccepted(true)} />
        </BrowserRouter>
    );
});

export default App;